// extracted by mini-css-extract-plugin
export default {"login":"index_login__Te9l4"};